// frontend/src/services/featuredService.js
import api from "../config/api";

const featuredService = {
  // Obtener items activos (público)
  getActive: async () => {
    try {
      const response = await api.get('/featured');
      return response.data;
    } catch (error) {
      console.error("Error fetching featured items:", error);
      return { success: false, data: [], message: 'Erro ao carregar destaques' };
    }
  },

  // Admin: Obtener todos los items
  getAll: async () => {
    try {
      const response = await api.get('/admin/featured');
      return response.data;
    } catch (error) {
      console.error("Error fetching featured items:", error);
      return { success: false, data: [] };
    }
  },

  // Admin: Crear
  create: async (formData) => {
    try {
      const response = await api.post('/admin/featured', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      console.error("Error creating featured item:", error);
      
      if (error.response?.status === 422) {
        return { 
          success: false, 
          message: 'Erro de validação',
          errors: error.response.data.errors || {}
        };
      }
      
      return { 
        success: false, 
        message: error.response?.data?.message || 'Erro ao criar destaque' 
      };
    }
  },

  // Admin: Actualizar
  update: async (id, formData) => {
    try {
      const response = await api.post(`/admin/featured/${id}?_method=PUT`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      console.error("Error updating featured item:", error);
      
      if (error.response?.status === 422) {
        return { 
          success: false, 
          message: 'Erro de validação',
          errors: error.response.data.errors || {}
        };
      }
      
      return { 
        success: false, 
        message: error.response?.data?.message || 'Erro ao atualizar destaque' 
      };
    }
  },

  // Admin: Toggle active
  toggleActive: async (id) => {
    try {
      const response = await api.patch(`/admin/featured/${id}/toggle-active`);
      return response.data;
    } catch (error) {
      console.error("Error toggling featured item:", error);
      return { success: false, message: 'Erro ao alterar status' };
    }
  },

  // Admin: Eliminar
  delete: async (id) => {
    try {
      const response = await api.delete(`/admin/featured/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting featured item:", error);
      return { success: false, message: 'Erro ao excluir destaque' };
    }
  }
};

export default featuredService;